import { endOfMonth, format, isValid, parseISO, startOfMonth } from 'date-fns';

export const EMPTY_ORDER_SUMMARY = {
    total_sales: 0,
    total_products: 0,
    average_ticket: 0,
    top_products: [],
};

/** Mês civil atual: dia 01 → último dia do mês. */
export function defaultOrdersDateRange(referenceDate = new Date()) {
    return {
        from: format(startOfMonth(referenceDate), 'yyyy-MM-dd'),
        to: format(endOfMonth(referenceDate), 'yyyy-MM-dd'),
    };
}

function parseOrdersDate(value) {
    if (!value || typeof value !== 'string') {
        return '';
    }
    const trimmed = value.trim();
    if (!/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
        return '';
    }
    const parsed = parseISO(trimmed);
    return isValid(parsed) ? trimmed : '';
}

export function normalizeOrdersDateRange(from, to) {
    let start = parseOrdersDate(from);
    let end = parseOrdersDate(to);

    if (start && end && start > end) {
        [start, end] = [end, start];
    }

    return { from: start, to: end };
}

export function ordersDateRangeForApi(from, to) {
    const { from: start, to: end } = normalizeOrdersDateRange(from, to);
    if (!start || !end) {
        return { from: null, to: null, error: 'Informe a data inicial e a data final.' };
    }
    return { from: start, to: end, error: null };
}

export function buildOrdersListQuery({ page, limit, q, from, to, salesChannelId }) {
    const params = new URLSearchParams();
    params.set('page', String(page));
    params.set('limit', String(limit));
    if (q) {
        params.set('q', q);
    }
    if (from) {
        params.set('from', from);
    }
    if (to) {
        params.set('to', to);
    }
    if (salesChannelId) {
        params.set('sales_channel_id', salesChannelId);
    }
    return params.toString();
}

export function buildOrdersSummaryQuery({ q, from, to, salesChannelId }) {
    const params = new URLSearchParams();
    if (q) {
        params.set('q', q);
    }
    if (from) {
        params.set('from', from);
    }
    if (to) {
        params.set('to', to);
    }
    if (salesChannelId) {
        params.set('sales_channel_id', salesChannelId);
    }
    return params.toString();
}

export function formatOrdersPeriodLabel(from, to) {
    if (!from || !to) {
        return '';
    }
    const [fromYear, fromMonth, fromDay] = from.split('-');
    const [toYear, toMonth, toDay] = to.split('-');
    return `${fromDay}/${fromMonth}/${fromYear} a ${toDay}/${toMonth}/${toYear}`;
}
